import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { buildQuery } from "../../additional/functions";
import { BaseQueryErrorHandler } from "./@utils/BaseQueryErrorHandler";

const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/api/v2/jwt-auth",
  prepareHeaders: (headers) => {
    headers.set("Content-Type", "application/json");

    return headers;
  },
});

const baseQuery = BaseQueryErrorHandler(rawBaseQuery);

export const userSettingsApi = createApi({
  reducerPath: "userSettingsApi",
  baseQuery,
  endpoints: (builder) => ({
    getTableSlotsList: builder.query({
      query: ({ email, tableId }) =>
        `/table_slots_list${buildQuery({ email, tableId })}`,
    }),
    getTableSlot: builder.query({
      query: ({ email, tableId, slotName }) =>
        `/table_slots${buildQuery({ email, tableId, slotName })}`,
    }),
    deleteTableSlot: builder.mutation({
      query: ({ email, tableId, slotName }) => ({
        url: `/table_slots${buildQuery({ email, tableId, slotName })}`,
        method: "DELETE",
      }),
    }),
    postTableSlots: builder.mutation({
      query: ({ email, tableId, slotName, newValues }) => ({
        url: `/table_slots/${email}`,
        method: "POST",
        body: { tableId, slotName, newValues },
      }),
    }),
  }),
});

export const {
  useGetTableSlotsListQuery,
  useLazyGetTableSlotQuery,
  useDeleteTableSlotMutation,
  usePostTableSlotsMutation,
} = userSettingsApi;
